import React, { useState } from 'react';
import { colors } from '../styles';

const styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '0.75rem 0.75rem',
    minHeight: '48px', // Touch target minimum
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: colors.textPrimary,
    minWidth: '0',
    width: '100%',
    boxSizing: 'border-box',
  },
  buttonHover: {
    backgroundColor: colors.surfaceHover,
    borderColor: colors.accent,
  },
  icon: {
    flexShrink: 0,
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

// Iconos simples para cada categoría
const CategoryIcon = ({ type }) => {
  const iconProps = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: colors.accent,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  switch (type) {
    case 'medical':
    case 'veterinaria':
      return (
        <svg {...iconProps}>
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
      );
    case 'pharmacy':
    case 'farmacia':
      return (
        <svg {...iconProps}>
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      );
    case 'park':
    case 'parques':
      return (
        <svg {...iconProps}>
          <path d="M17 14V2"/>
          <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76l4.51 7.17"/>
          <circle cx="9" cy="18" r="4"/>
        </svg>
      );
    case 'house':
    case 'pension':
      return (
        <svg {...iconProps}>
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      );
    case 'scissors':
    case 'estilistas':
      return (
        <svg {...iconProps}>
          <circle cx="6" cy="6" r="3"/>
          <circle cx="6" cy="18" r="3"/>
          <line x1="20" y1="4" x2="8.12" y2="15.88"/>
          <line x1="14.47" y1="14.48" x2="20" y2="20"/>
          <line x1="8.12" y1="8.12" x2="12" y2="12"/>
        </svg>
      );
    case 'walk':
    case 'paseadores':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="5" r="2"/>
          <path d="M12 7v6l3 5"/>
          <path d="M9 18l3-5"/>
          <path d="M7 12h10"/>
        </svg>
      );
    case 'training':
    case 'entrenadores':
      return (
        <svg {...iconProps}>
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
          <path d="M4 22h16"/>
          <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
          <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
          <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
        </svg>
      );
    case 'care':
    case 'cuidadores':
      return (
        <svg {...iconProps}>
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      );
    case 'key':
    case 'cerrajeria':
      return (
        <svg {...iconProps}>
          <path d="m21 2-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/>
        </svg>
      );
    case 'store':
    case 'conveniencia':
      return (
        <svg {...iconProps}>
          <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"/>
          <path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"/>
          <path d="M12 3v6"/>
        </svg>
      );
    case 'wrench':
    case 'mecanico':
      return (
        <svg {...iconProps}>
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
        </svg>
      );
    default:
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"/>
        </svg>
      );
  }
};

export default function CategoryButton({ categoria, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      style={{
        ...styles.button,
        ...(hovered ? styles.buttonHover : {}),
      }}
      onClick={() => onClick && onClick(categoria)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span style={styles.icon}>
        <CategoryIcon type={categoria.icono || categoria.id} />
      </span>
      <span style={styles.text}>{categoria.nombre}</span>
    </button>
  );
}
